var render = function render(){var _vm=this,_c=_vm._self._c;return _c('memlist-modal',{ref:"login-form",attrs:{"size":"lg","visible":_vm.show_modal,"hide-footer":""},on:{"close":function($event){_vm.show_modal = false}}},[_c('MemberTabbedLogin',{staticStyle:{"margin":"auto"},attrs:{"is_modal":true},on:{"authenticated":_vm.authenticated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }